// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarCaja_main__CO5re","intro":"ModalEditarCaja_intro__c2kuQ","input":"ModalEditarCaja_input__lY5YP"};